// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"85":"mobile","367":"personalspace","388":"result","962":"home"}[chunkId] || chunkId) + "." + {"85":"0253594d","127":"edf8b61d","367":"bd81fdef","388":"33a6c8e3","477":"1705719f","962":"e658d0fc"}[chunkId] + ".js";
};